import React, { Component } from "react";
import { connect } from "react-redux";
import Server from "./Server.js";
import Footer from "./Footer.js";
import LoginBox from "./LoginBox.js";
import Poll from "./Poll.js";
import { Dialog } from "primereact/dialog";
import { Link, Navigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import ContentSlider from "./ContentSlider";
import { SelectButton } from "primereact/selectbutton";
import Swiper from "react-id-swiper";
import { Button, Drawer, Radio, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const params5 = {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: 1,
  centeredSlides: true,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: true,
    logo1: null
  },
  pagination: {
    el: ".swiper-pagination",
  },
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    localStorage.removeItem("food");
    this.Server = new Server();
    this.state = {
      activePage: 1,
      CurrentTab: 1,
      poll: {},
      credit: 0,
      ads: [],
      BankBox: false,
      appData: this.props.appData,
      shops: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      System: this.Server.getSystem(),
    };
    this.getAppData = this.getAppData.bind(this);
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = (response) => {
      this.setState(
        {
          userId: response.data.authData.userId,
        },
        () => {
          if (!this.props.appData.lName) {
            this.getAppData();
          } else {
            this.getUser();
          }
        }
      );
    };
    let ECallBack = (error) => {
      this.setState({
        loading: 0,
      });
      if (!this.props.appData.lName) {
        this.getAppData();
      } else {
        this.getUser();
      }
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
    /*
    this.Server.send("MainApi/getduplicateusers", {}, (response)=>{
      console.log(response)
    }, ()=>{

    });*/

    
  }

  addClose(){
    this.setState({
      openAds: false
    })
  }

  getAppData() {
    let that = this;
    this.setState({
      ShowLoading: true,
    });
    let SCallBack = function (response) {
      const appData = response.data.result[0] || {};
      that.getPoll();
      that.setState({
        appData: appData,
        ads: response.data.ads ? response.data.ads : [],
        openAds: response.data.ads.length > 0 ? true : false,
        inChange: response.data.inchange || false
      },()=>{
        that.getUser();
      });

      that.props.dispatch({
        type: "noLogin",
        appData: appData,
        systemId: that.state.System?.id
      });
      if (appData.multiSystem && (!that.state.System || !that.state.System.id)) {
        that.setState({
          showSystemBox: true,
        });
      }
    };
    let ECallBack = function (error) {
      that.setState({
        ShowLoading: false,
      });
    };
    const condition = this.state.System
      ? { condition: { code: this.state.System.code } }
      : { condition: { code: 1000 } };
    this.Server.send("MainApi/getAppData", condition, SCallBack, ECallBack);
  }
  getPoll(){
    let that = this;
    this.Server.send(
      "https://newcrm.iran.liara.run/AdminApi/getPollInApp",
      {},
      function (response) {
        if(response.data.result && response.data.result[0]){
          that.setState({
            showPoll: true,
            poll: response.data.result[0]
          })
        }
      },
      function () {
       
      },
    true);
  }
  getUser() {
    if(!this.props.mobile){
      this.setState({
        ShowLoading: 0,
      });
      this.getPics();
      if (this.state.appData.showShops) this.getshopsGroups();
      return;
    }
    let that = this;
    this.Server.send(
      "MainApi/getuser",
      { username: this.props.mobile, noPass: 1, userId: this.state.userId },
      function (response) {
        localStorage.setItem("api_token", response.data.token);
        if (that.state.appData.showShops) that.getshopsGroups();
        if (
          !that.state.System ||
          (that.state.System && !that.state.System.subSystem)
        )
          that.getPics();
        else {
          that.setState({
            ShowLoading: 0,
            hidePics: true,
          });
        }
      },
      function () {
        that.setState({
          page: "/",
        });
      }
    );
  }

  getshopsGroups() {
    let that = this;
    this.Server.send(
      "AdminApi/getShopGroup",
      { linit: 10 },
      function (response) {
        let shopGroups = [];

        for (let i = 0; i < response.data.result.length; i++) {
          shopGroups.push({
            label: response.data.result[i].name,
            value: response.data.result[i]._id,
          });
          if (response.data.result[i].showInApp)
            that.getshopsFroApp(
              response.data.result[i]._id,
              response.data.result[i].name
            );
        }
        that.setState({
          shopGroups: shopGroups,
        });
      },
      function () {}
    );
  }
  getshopsFroApp(shopGroup, name) {
    let that = this;
    this.Server.send(
      "MainApi/getshopsFroApp",
      { shopGroup: shopGroup, getPayments: true },
      function (response) {
        let shops = that.state.shops;
        shops.push({
          list: response.data.result
            .map((item) => {
              // let count = 0;
              // item.credit_payment.map((item2) => {
              //   if (item2.type == 1) {
              //     count++;
              //   }
              // });
              return {
                title: item.name,
                image: item.SpecialPic,
                desc: item.address,
                _id: item._id,
                // payCount: count,
              };
            })
            .sort((a, b) =>
              a.payCount > b.payCount ? -1 : b.payCount > a.payCount ? 1 : 0
            ),
          groupName: name,
          groupId: shopGroup,
        });
        that.setState({
          shops: shops,
        });
      },
      function () {}
    );
  }
  getPics() {
    let that = this;
    this.Server.send(
      "MainApi/getPics",
      {},
      function (response) {
        response.data.result.map(function (item, index) {
          //that.getUser();
          
          if (item.name == "extra-file1") {
            that.setState({
              logo1: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link1: item.link,
            });
          }

          if (item.name == "extra-file2")
            that.setState({
              logo2: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link2: item.link,
            });
          if (item.name == "extra-file3")
            that.setState({
              logo3: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link3: item.link,
            });
          if (item.name == "file4")
            that.setState({
              logo4: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link4: item.link,
              text4: item.text,
            });

          if (item.name == "file5")
            that.setState({
              logo5: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link5: item.link,
              text5: item.text,
            });
          if (item.name == "file8")
            that.setState({
              logo8: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link8: item.link,
              text8: item.text,
            });
          if (item.name == "file9")
            that.setState({
              logo9: item.fileUploaded
                ? that.state.absoluteUrl +
                  item?.fileUploaded?.split("public")[1]
                : null,
              link9: item.link,
              text9: item.text,
            });
          if (item.name == "file11") {
            that.setState({
              SpecialImage:
                that.state.absoluteUrl + item?.fileUploaded?.split("public")[1],
            });
          }
          if (item.name == "file13") {
            that.setState({
              loading_pic:
                that.state.absoluteUrl + item?.fileUploaded?.split("public")[1],
            });
          }
        });

        /*setTimeout(() => {
          that.setState({
            ShowLoading: 0,
          });
        }, 1);*/
      },
      function () {}
    );
  }

  render() {
    if (this.state.page) {
      return <Navigate to={this.state.page} />;
    }
    if (this.state.shopGroup) {
      return <Navigate to={`/ShopList?_id=${this.state.shopGroup}`} />;
    }

    return (
      this.state.inChange ?
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:"100%",flexDirection:'column'}}>
          <img src="https://chamrancity.ir/wp-content/uploads/2022/10/Untitled-6-1-1100x700.jpg" style={{width:'100%'}} />
          <p style={{textAlign:'center',fontWeight:'bold'}}>... سامانه در حال به روزرسانی میباشد</p>
        </div>
      :
      <div style={{ height: "100%" }} className="sarv-bg1 sarv-home-top-box">
        {!this.state.ShowLoading ? (
          <div className="sarv-bg1 sarv-home-top-box">
            <div className="sarv-home-top-box">
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 30,
                    width: "100%",
                  }}
                >
                  <div>
                    {this.props.mobile ? (
                      <div style={{ marginLeft: 15 }}>
                        <span>
                          <span>
                            {this.props.fullname
                              ? this.props.fullname
                              : this.props.mobile}
                          </span>
                          <span> خوش آمدید </span>
                        </span>
                      </div>
                    ) : (
                      <div
                        className="template"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          className="google p-0 p-button-sm p-button-danger"
                          danger
                          aria-label="Google"
                          onClick={() => {
                            this.setState({
                              showLogin: true,
                            });
                          }}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            minWidth: 125,
                            marginLeft: 15,
                          }}
                        >
                          <span className="px-3" style={{marginRight:5}}>ورود به سامانه</span>

                          <i className="pi pi-user"></i>
                        </Button>
                      </div>
                    )}
                  </div>
                  <div style={{ marginRight: 20 }}>
                    <img
                      src={`./icons/${this.state.appData?.lName}/logo.png`}
                      style={{ width: 40 }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ display: this.state.BankBox ? "none" : "block" }}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                    width: "98%",
                    fontSize: 13,
                    minHeight:
                      this.state.appData &&
                      this.state.appData.features &&
                      this.state.appData.features.services &&
                      this.state.appData.features.services.length > 8
                        ? 400
                        : 300,
                  }}
                >
                  {this.state.appData?.features?.services.map((item, index) => {
                    return (
                      (this.props.username ||
                        !item[3] ||
                        this.state.appData.hasBank) && (
                        <div
                          style={{
                            minWidth: 85,
                            width: "25%",
                            height: 60,
                            marginTop: 10,
                          }}
                          key={index}
                        >
                          {item[2] ? (
                            item[2] == "/" &&
                            this.state.appData.noForceLogin ? (
                              <div
                                style={{
                                  position: "relative",
                                  textAlign: "left",
                                }}
                                onClick={() => {
                                  this.Server.send(
                                    "MainApi/logout",
                                    {},
                                    () => {
                                      this.setState({
                                        ShowLoading: true,
                                      });
                                      this.props.dispatch({
                                        type: "logout",
                                        appData: this.state.appData,
                                        systemId: this.state.System?.id
                                      });
                                      setTimeout(() => {
                                        this.setState({
                                          ShowLoading: false,
                                        });
                                      }, 1500);
                                    },
                                    () => {
                                      alert("error");
                                    }
                                  );
                                }}
                              >
                                <div
                                  style={{
                                    borderRadius: 13,
                                    color: "#000",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <img
                                    src={`./icons/${this.state.appData?.lName}/${item[1]}`}
                                    style={{ width: 48 }}
                                  />
                                  <span className="iranyekanwebmedium sarv-title1">
                                    {item[0]}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <Link
                                style={{
                                  position: "relative",
                                  textAlign: "left",
                                }}
                                to={`${process.env.PUBLIC_URL}${item[2]}`}
                              >
                                <div
                                  style={{
                                    borderRadius: 13,
                                    color: "#000",
                                    textAlign: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                  }}
                                >
                                  <img
                                    src={`./icons/${this.state.appData?.lName}/${item[1]}`}
                                    style={{ width: 48 }}
                                  />
                                  <span className="iranyekanwebmedium sarv-title1">
                                    {item[0]}
                                  </span>
                                </div>
                              </Link>
                            )
                          ) : (
                            <div
                              style={{
                                position: "relative",
                                textAlign: "left",
                                opacity: "0.5",
                              }}
                            >
                              <div
                                style={{
                                  borderRadius: 13,
                                  color: "#000",
                                  textAlign: "center",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "space-around",
                                }}
                              >
                                <img
                                  src={`./icons/${this.state.appData?.lName}/${item[1]}`}
                                  style={{ width: 48 }}
                                />
                                <span className="iranyekanwebmedium sarv-title1">
                                  {item[0]}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    );
                  })}
                  {this.props.creditPrice && (
                    <div
                      style={{
                        minWidth: 85,
                        width: "25%",
                        height: 60,
                        marginTop: 10,
                      }}
                    >
                      <Link
                        style={{ position: "relative", textAlign: "left" }}
                        to={`${process.env.PUBLIC_URL}/CreditPrice`}
                      >
                        <div
                          style={{
                            borderRadius: 13,
                            color: "#000",
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-around",
                          }}
                        >
                          <img
                            src={`./icons/${this.state.appData?.lName}/app-icon-4.png`}
                            style={{ width: 48 }}
                          />
                          <span className="iranyekanwebmedium sarv-title1">
                            اعتبار نقدی
                          </span>
                        </div>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!this.state.hidePics && this.state.logo1 &&  (
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  zIndex: 2,
                }}
              >
                <div style={{ width: "90%" }}>
                  <div>
                    {this.state.logo1 && this.state.link1 &&
                    this.state.link1.indexOf("http") > -1 ? (
                      <Link
                        to={this.state.link1}
                        className=""
                        style={{ textDecoration: "none" }}
                      >
                        <img
                          src={this.state.logo1}
                          style={{
                            borderRadius: 12,
                            whiteSpace: "pre-wrap",
                            height: 196,
                            width: "100%",
                          }}
                          title={this.state.text1}
                        />
                      </Link>
                    ) : (
                      <Link
                        to={`${process.env.PUBLIC_URL}/` + this.state.link1}
                        className=""
                        href="#"
                        style={{ textDecoration: "none" }}
                      >
                        <img
                          src={this.state.logo1}
                          style={{
                            borderRadius: 12,
                            whiteSpace: "pre-wrap",
                            height: 196,
                            width: "100%",
                          }}
                          title={this.state.text1}
                        />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            )}
            {this.state.shopGroups && this.state.shopGroups.length > 0 && (
              <div
                style={{ textAlign: "right", direction: "rtl", padding: 10 }}
              >
                <SelectButton
                  style={{ border: 0 }}
                  className="sarv-selectBotten"
                  value={this.state.shopGroup}
                  options={this.state.shopGroups}
                  onChange={(e) => {
                    this.setState({
                      shopGroup:
                        e.value === null ? this.state.shopGroup : e.value,
                    });
                  }}
                ></SelectButton>
              </div>
            )}
            {this.state.shops &&
              this.state.shops.map((item, index) => {
                return (
                  <div key={index}>
                    <ContentSlider
                      key={index}
                      data={item.list}
                      showAllLink={`ShopList?_id=${item.groupId}`}
                      title={item.groupName}
                    />
                  </div>
                );
              })}
            <div style={{ height: 80 }}></div>
            <div
              style={{ position: "fixed", bottom: 0, width: "100%" }}
              className="sarv-footer"
            >
              {this.state.appData && this.state.appData.lName && (
                <Footer
                  noBack="1"
                  appData={this.state.appData}
                  bgColor="#fff"
                />
              )}
            </div>
            <Dialog
              header="انتخاب سیستم"
              visible={this.state.showSystemBox}
              maximized={true}
              closable={true}
              resizable={false}
              draggable={false}
              onHide={() => {
                this.setState({
                  showSystemBox: false,
                });
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <LoginBox
                  appData={this.state.appData}
                  onlyShowSystemBox={true}
                  AfterChangeSystem={(systemId) => {
                    localStorage.setItem("systemId", systemId);
                    this.props.dispatch({
                      type: "noLogin",
                      appData: this.state.appData,
                      systemId: systemId,
                    });
                    this.setState({
                      showSystemBox: false,
                    });
                  }}
                />
              </div>
            </Dialog>
            <Dialog
              visible={this.state.showLogin}
              maximized={true}
              closable={true}
              resizable={false}
              draggable={false}
              onHide={() => {
                this.setState({
                  showLogin: false,
                });
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <LoginBox
                  appData={this.state.appData}
                  AfterLogin={(variables) => {
                    this.setState({
                      showLogin: false,
                    });
                  }}
                />
              </div>
            </Dialog>
                <Dialog
                    visible={this.state.showPoll}
                    maximized={true}
                    closable={true}
                    resizable={false}
                    draggable={false}
                    onHide={() => {
                      this.setState({
                        showPoll: false,
                      });
                    }}
                >
                    <div
                    style={{
                      height:"100%"
                    }}
                    >
                    <Poll poll={this.state.poll} noHeader={true} afterEnd={()=>{
                      this.setState({
                        showPoll: false
                      })
                    }} />
                    </div>
                </Dialog>
                <Drawer
                  placement="top"
                  onClose={()=>{
                    this.addClose()
                  }}
                  open={this.state.openAds}
                  bodyStyle ={{overflow: 'hidden'}}
                >
                  <div>
                  
                  <Swiper {...params5}>
                    {this.state.ads && this.state.ads.map((item)=>{
                      return(
                        <Link to={item.link} className=""  style={{ textDecoration: 'none',color:"#000",textAlign:'center'}}>
                          {item.title &&
                           <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                           <p style={{textAlign:'center',marginRight:20,fontSize:25}}>{item.title}</p>
                           <CheckOutlined style={{fontSize:25,color:'green',fontWeight:'bolder'}} />
                         </div>
                          }
                          {item.subTitle &&
                           <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                           <p style={{textAlign:'center',marginRight:20,fontSize:25}}>{item.title}</p>
                           <CheckOutlined style={{fontSize:25,color:'green',fontWeight:'bolder'}} />
                         </div>
                          }
                         {item.imageTitle &&
                           <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                           <img
                          src={
                            item.imageTitle
                          }
                          style={{
                            width: "60%",

                          }}
                        />
                         </div>
                          }
                        <div style={{position: "relative"}}>
                        
                           <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                            <img
                          src={
                            (item.image
                              ? item.image
                              : "nophoto.png")
                          }
                          style={{
                            borderRadius: 5,
                            whiteSpace: "pre-wrap",
                            maxHeight: 260,
                            width: "100%",
                          }}
                        />
                        {item.imageSubTitle &&
                           <img
                          src={
                            item.imageSubTitle
                          }
                          style={{
                            width: "65%",
                            position: "absolute",
                            top:5,

                          }}
                        />
                        }
                         </div>
                         
                          
                        </div>  
                        
                      </Link>
                      )
                      
                    })}
                    </Swiper>
                    </div>
                </Drawer>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    LoginAnia: state.LoginAnia,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(Home);
